<app-help-page mainVideo="custom-dashboard-report"
               [tutorials]="['dashboard-reports', 'dimension-picker', 'metric-picker', 'adloop-calendar',  'adloop-filters', 'step-report-creation', 'cookie-consent']"
               [videos]="['custom-dashboard-report', 'filters-orders-report', 'report-saving-sharing', 'quick-dashboard', 'report-templates']"></app-help-page>
